import { IANAZone, DateTime as LuxonDateTime } from "luxon";

const timeZoneMap: Record<string, string> = {
  "Pacific Daylight Time": "America/Los_Angeles",
  "Pacific Standard Time": "America/Los_Angeles",
  "Mountain Daylight Time": "America/Denver",
  "Mountain Standard Time": "America/Denver",
  "US Mountain Standard Time": "America/Phoenix",
  "Central Daylight Time": "America/Chicago",
  "Central Standard Time": "America/Chicago",
  "Eastern Daylight Time": "America/New_York",
  "Eastern Standard Time": "America/New_York"
};

export class DateTime extends LuxonDateTime {
  /** Convert a C# timezone name into the IANA time zone value. */
  static getZone(name: string): IANAZone {
    const ianaZone = timeZoneMap[name];
    if (!ianaZone) throw `Failed to find IANAZone value with C# zone key {${name}}.`;
    if (!IANAZone.isValidZone(ianaZone))
      throw `Luxon failed to parse the mapped IANA value {${ianaZone}} from key {${name}}.`;
    return IANAZone.create(ianaZone);
  }
}
